// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/images/baloa_play_header_buscador.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-play-search__container {
    margin: 24px 64px 0 64px;
    padding: 30px 24px;
    width: -webkit-fill-available;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 240px;
    background-repeat: no-repeat;
    background-size: cover;
    display: inline-block;
    border-radius: 12px;
}

.baloa-play-search__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.baloa-play-search__header .baloa-body-bold {
    font-size: 35px;
    line-height: normal;
    color: var(--white-color);
}

.baloa-play-search__container .baloa-subtitle-1 {
    color: var(--white-color);
    margin-top: 33px;
}

.baloa-play-search__buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 33px;
}
.baloa-play-search__buttons .input-search-with-button__input {
    width: 417px;
}

.baloa-play-search__buttons__links-container {
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 8px;
}

.baloa-play-search__buttons__link .icon{
    grid-area: void;
    margin-left: 6px;
}

.baloa-play-search__buttons__link .text-button:hover, .baloa-play-search__buttons__link .text-button:active {
    background: transparent;
}

.baloa-play-search__buttons__link .text-button {
    color: var(--white-color);
}

.baloa-play-search__buttons__link .button {
    padding: 12px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 

    .baloa-play-search__container {
        margin: 0;
        border-radius: 0;
        padding: 20px 16px 16px 16px;
        height: auto;
    }


    .baloa-play-search__header .text-button.button {
        padding: 6px 10px;
        line-height: normal;
        font-size: 14px;
        color: var(--primary-very-dark-color);
        background: var(--white-color);
    }

    .baloa-play-search__header .text-button .icon {
        grid-area: icon;
        margin-right: 4px;
    }

    .baloa-play-search__header .baloa-body-bold {
        font-size: 20px;
    }

    .baloa-play-search__container .baloa-subtitle-1 {
        font-size: 15px;
        margin-top: 16px;
    }

    .baloa-play-search__buttons {
        flex-direction: column;
        margin-top: 12px;
        gap: 12px;
    }

    .baloa-play-search__buttons .button {
        width: 100%;
        line-height: normal;
    }

    .baloa-play-search__buttons__search {
        width: 100%;
    }

    .baloa-play-search__buttons .input-search-with-button__input {
        width: calc(100% - 46px);
    }

    .baloa-play-search__buttons .input-search-with-button__icon.MuiButtonBase-root.MuiIconButton-root {
        padding: 10px 14px;
    }

    .baloa-play-search__buttons .input-search-with-button__input.MuiFormControl-root .MuiOutlinedInput-root {
        padding: 10px;
    }

    .baloa-play-search__buttons__links-container {
        justify-content: space-around;
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-play/components/baloa-play-search-component/BaloaPlaySearchComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,6BAA6B;IAC7B,yDAAqE;IACrE,aAAa;IACb,4BAA4B;IAC5B,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,SAAS;QACT,gBAAgB;QAChB,4BAA4B;QAC5B,YAAY;IAChB;;;IAGA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,eAAe;QACf,qCAAqC;QACrC,8BAA8B;IAClC;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,6BAA6B;QAC7B,WAAW;IACf;AACJ","sourcesContent":[".baloa-play-search__container {\n    margin: 24px 64px 0 64px;\n    padding: 30px 24px;\n    width: -webkit-fill-available;\n    background-image: url('assets/images/baloa_play_header_buscador.png');\n    height: 240px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    display: inline-block;\n    border-radius: 12px;\n}\n\n.baloa-play-search__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.baloa-play-search__header .baloa-body-bold {\n    font-size: 35px;\n    line-height: normal;\n    color: var(--white-color);\n}\n\n.baloa-play-search__container .baloa-subtitle-1 {\n    color: var(--white-color);\n    margin-top: 33px;\n}\n\n.baloa-play-search__buttons {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 33px;\n}\n.baloa-play-search__buttons .input-search-with-button__input {\n    width: 417px;\n}\n\n.baloa-play-search__buttons__links-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    gap: 8px;\n}\n\n.baloa-play-search__buttons__link .icon{\n    grid-area: void;\n    margin-left: 6px;\n}\n\n.baloa-play-search__buttons__link .text-button:hover, .baloa-play-search__buttons__link .text-button:active {\n    background: transparent;\n}\n\n.baloa-play-search__buttons__link .text-button {\n    color: var(--white-color);\n}\n\n.baloa-play-search__buttons__link .button {\n    padding: 12px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n\n    .baloa-play-search__container {\n        margin: 0;\n        border-radius: 0;\n        padding: 20px 16px 16px 16px;\n        height: auto;\n    }\n\n\n    .baloa-play-search__header .text-button.button {\n        padding: 6px 10px;\n        line-height: normal;\n        font-size: 14px;\n        color: var(--primary-very-dark-color);\n        background: var(--white-color);\n    }\n\n    .baloa-play-search__header .text-button .icon {\n        grid-area: icon;\n        margin-right: 4px;\n    }\n\n    .baloa-play-search__header .baloa-body-bold {\n        font-size: 20px;\n    }\n\n    .baloa-play-search__container .baloa-subtitle-1 {\n        font-size: 15px;\n        margin-top: 16px;\n    }\n\n    .baloa-play-search__buttons {\n        flex-direction: column;\n        margin-top: 12px;\n        gap: 12px;\n    }\n\n    .baloa-play-search__buttons .button {\n        width: 100%;\n        line-height: normal;\n    }\n\n    .baloa-play-search__buttons__search {\n        width: 100%;\n    }\n\n    .baloa-play-search__buttons .input-search-with-button__input {\n        width: calc(100% - 46px);\n    }\n\n    .baloa-play-search__buttons .input-search-with-button__icon.MuiButtonBase-root.MuiIconButton-root {\n        padding: 10px 14px;\n    }\n\n    .baloa-play-search__buttons .input-search-with-button__input.MuiFormControl-root .MuiOutlinedInput-root {\n        padding: 10px;\n    }\n\n    .baloa-play-search__buttons__links-container {\n        justify-content: space-around;\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
